<!-- the ngFor inside the ng-container and the ngIf inside the section is only for the animation... ask Asaf. &ndash;&gt;-->
@for (section of facetSections; track section; let i = $index) {
    @if (i === profileOutputService.selectedIndex) {
        <section>
            @if (isLoading) {
                <exl-citation-brief-placeholder
                    [copies]="getNumOfCopies()"
                    class="content-placeholders"
                    @opacityOutAnimation
                >
                </exl-citation-brief-placeholder>
            }
            @for (item of outputGroup | paginate: paginationConfig; track trackByAsset(i, item); let i = $index) {
                <exl-citation-brief
                    #briefElem
                    [title]="item.esploroRecord.title | concat: ': ' : item.esploroRecord.titleSubtitle"
                    [titleHeaderLevel]="3"
                    (titleClick)="onTitleClick(item)"
                    (actionClick)="onActionClick($event, item, i)"
                    (authorClick)="onAuthorClick()"
                    [titleClickable]="isTitleClickable()"
                    [authors]="item.author"
                    [type]="'portal.' + item.type"
                    [postType]="
                        item.displaySubTypeInTitle && item.esploroRecord?.resourceSubtype
                            ? ' - ' +
                              (item.esploroRecord?.resourceSubtype
                                  | defaultTranslate: { default: item.esploroRecord?.resourceSubtype })
                            : ''
                    "
                    [actions]="item.action"
                    [menuActions]="item.menu"
                    [lines]="item.lines"
                    [dateLine]="item.date"
                    [status]="getAssetStatusToDisplay(item)"
                    [publisher]="item.esploroRecord.publisher"
                    [modified]="item.dateModification"
                    [dateLabel]="item.dateLabel"
                    [altmetric]="!item.isReservedDOI && displayAltmetric"
                    [doi]="item.doi"
                    [hidden]="
                        !isPublicPage &&
                        (!item.displayInPortal || item.isAssetSuppressed || !item.visibleInPublicProfile)
                    "
                    class="is-hoverable"
                    [exlAutomationMmsid]="item.mmsId"
                    [router]="item.assetRelativeUrl"
                    [queryParams]="{ institution: institutionCode }"
                >
                    <!-- content projection: Library communication -->
                    @if (!isPublicPage && item.notification?.currNote) {
                        <exl-citation-brief-notification
                            exl-slot-pre-brief
                            [notification]="item.notification.currNote"
                            color="accent"
                            [actions]="item.notificationActions"
                            (action)="onNotificationAction($event, item.notification, item)"
                            [icon]="'alert-decagram'"
                        >
                        </exl-citation-brief-notification>
                    }
                    <ng-container slot="additional-status-tags">
                        @if (item.isAssetOpenAccess) {
                            <mulo-separator orientation="vertical" [length]="14"></mulo-separator>
                            <mulo-status-tag
                                flavor="plain"
                                [icon]="useAltOAIcon() ? 'reading' : 'open-access'"
                                class="open-acces"
                            >
                                {{ 'research.results.openaccess' | translate }}
                            </mulo-status-tag>
                        }
                        @if (item.isPeerReview) {
                            <mulo-separator
                                orientation="vertical"
                                [length]="14"
                                class="margin-right-xs"
                            ></mulo-separator>
                            <mulo-status-tag flavor="plain" icon="peer-reviewed" class="peer-reviewed">
                                {{ 'research.results.peerreviewed' | translate }}
                            </mulo-status-tag>
                        }
                        @if (item.userCanEdit === false && !isPublicPage) {
                            <mulo-status-tag
                                [tooltip]="'research.portal.fulldisplay.lockedForRevisions.tooltip' | translate"
                                >{{ 'research.portal.fulldisplay.lockedForRevisions' | translate }}
                            </mulo-status-tag>
                        }
                        @if (!item.visibleInPublicProfile) {
                            <mulo-status-tag [description]="'research.profile.hide.status.hidden.tooltip' | translate">
                                {{ 'research.profile.hide.status.hidden' | translate }}
                            </mulo-status-tag>
                        }
                    </ng-container>
                    @if (!isPublicPage && !isDraft(item) && item.notification?.notifications.length > 0) {
                        <ng-container exl-slot-custom-actions>
                            <button
                                mat-icon-button
                                [matTooltip]="'research.output.list.action.message.list' | translate"
                                (click)="openMessagesDialog(item)"
                                [color]="'primary'"
                                attr.aria-label="{{ 'research.output.list.action.message.list' | translate }}"
                            >
                                <mat-icon class="mat-icon-rtl-mirror" svgIcon="message-text">
                                    <span [ngClass]="item.notification?.currNote ? 'message-active' : ''"></span>
                                </mat-icon>
                            </button>
                        </ng-container>
                    }
                    @if (showHighlightButton(item)) {
                        <ng-container exl-slot-custom-actions>
                            <exl-button-splash
                                [splashIcon]="!inHighlightsList(item) ? 'star' : 'star-outline'"
                                (clicked)="onHighlightClick(item, i)"
                                [color]="inHighlightsList(item) || item.highlightHover ? 'primary' : null"
                                [ariaLabel]="getHighlightsTooltip(item)"
                                (mouseenter)="item.highlightHover = true"
                                (mouseleave)="item.highlightHover = false"
                            >
                                @if (inHighlightsList(item) && item.highlightHover) {
                                    <mat-icon svgIcon="star-off"></mat-icon>
                                }
                                @if (inHighlightsList(item) && !item.highlightHover) {
                                    <mat-icon svgIcon="star"></mat-icon>
                                }
                                @if (!inHighlightsList(item)) {
                                    <mat-icon svgIcon="star-outline"></mat-icon>
                                }
                            </exl-button-splash>
                        </ng-container>
                    }
                    @if (!isPublicPage) {
                        <div class="visibility">
                            @if (!item.displayInPortal) {
                                <mat-icon
                                    muloSvgViewbox
                                    svgIcon="public-off"
                                    class="margin-right-xs"
                                    [matTooltip]="'research.visibility.noPortal' | translate"
                                ></mat-icon>
                            }
                            @if (item.isAssetSuppressed) {
                                <mat-icon
                                    muloSvgViewbox
                                    svgIcon="person-off"
                                    class="margin-right-xs"
                                    [matTooltip]="'research.visibility.noProfiles' | translate"
                                ></mat-icon>
                            }
                            @if (!item.displayInPortal && item.isAssetSuppressed) {
                                <span>{{ 'research.visibility.noPnP' | translate }}</span>
                            }
                            @if (!item.displayInPortal && !item.isAssetSuppressed) {
                                <span>{{ 'research.visibility.noPortal' | translate }}</span>
                            }
                            @if (item.displayInPortal && item.isAssetSuppressed) {
                                <span>{{ 'research.visibility.noProfiles' | translate }}</span>
                            }
                        </div>
                    }
                    @if (profileAssetEnrichmentService.getAbstractDescription(item); as desc) {
                        <mulo-expandable
                            class="abstract"
                            buttonPosition="right"
                            [expandLabel]="'research.general.showMore' | translate"
                            [collapseLabel]="'research.general.showLess' | translate"
                            [ratio]="3"
                        >
                            <p class="rich-text-reset" [innerHTML]="desc | htmlSanitize"></p>
                        </mulo-expandable>
                    }
                </exl-citation-brief>
            }
            @if (!isLoading && multiplePages) {
                <mulo-floating-toolbar>
                    <pagination-template
                        #p="paginationApi"
                        [id]="paginationConfig.id"
                        (pageChange)="pageChange($event)"
                        [maxSize]="7"
                        slot="toolbar-middle"
                    >
                        <mulo-paging
                            id="pagination"
                            [data]="p"
                            [previousLabel]="'research.search.results.previous' | translate"
                            [nextLabel]="'research.search.results.next' | translate"
                            [screenReaderJumpLabel]="'research.aria.results.page.jump.button' | translate"
                            [directionLinksAsIcons]="media.is('xs')"
                        ></mulo-paging>
                    </pagination-template>
                </mulo-floating-toolbar>
            }
        </section>
    }
}

<ng-template #viewDialog let-data>
    <button
        mat-mini-fab
        class="esp-view-dialog-close has-shadow"
        matDialogClose
        aria-label="{{ 'research.aria.dialog.close.dialog' | translate }}"
    >
        <mat-icon svgIcon="close"></mat-icon>
    </button>
    <iframe [title]="data.title" [src]="data?.permalink | safeUrl"></iframe>
</ng-template>
